import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

import { LAYOUT_HEADER_HEIGHT } from '../../constants/layoutConstants'

interface DocumentsDropzoneWrapperProps {
  heightOffset?: number
  isDragActive?: boolean
}

export const DocumentsDropzoneWrapper = styled.div<DocumentsDropzoneWrapperProps>`
  display: grid;
  flex: 1;
  width: 100%;
  min-height: calc(100vh - ${({ heightOffset = LAYOUT_HEADER_HEIGHT }) => heightOffset}px);
  margin-bottom: 16px;
  border-radius: ${BorderRadius.R16};
  ${({ isDragActive }) =>
    isDragActive &&
    `
      outline: 2px dashed ${Color.Grey300};
      border-top: 2px dashed ${Color.Grey300}; // border-top backfills the top edge, which SimpleBar clips off of the outline
    `}
`
